import * as React from 'react';
import { SingleColumnLayout } from '../_layouts/SingleColumnLayout';
import { PageHeader } from '../../designSystem/PageHeader';
import { H2 } from '../../designSystem/typography/Heading';
import { PublicPageWrapper } from '../_pageWrappers/PublicPageWrapper';


export default function InsufficientPermissionPage(): JSX.Element{

    
    
    return ( 
        <PublicPageWrapper>
            <PageHeader narrow headerText="Du mangler brugerrettigheder" headerStyle="secondary-gray" />
            <SingleColumnLayout narrow>
                <>
                    <H2>Du har forsøgt at tilgå funktionalitet som du ikke har rettigheder til</H2>
                    <p>
                        Det er sandsynligvis en forglemmelse fra din administrators side. Tag fat i en AMORG administrator i din arbejdsmiljøorganisation.
                        Vedkommende kan rette din adgang med det samme.<br />
                        <br />
                        Mvh. AMORG
                    </p>
                </>
            </SingleColumnLayout>
        </PublicPageWrapper>

    );
}